<template>
  <div class="login-main-container">
    <div class="container flash-message-top-container">
      <flash-message class="flash-message-top"></flash-message>
    </div>
    <div class="container text-center login-container container-admin">
      <h3>{{title}}</h3>
      <div class="form-group login-fields">
        <div class="label-left">
           <label for="txtLogin">Login</label>
           <input type="text" class="form-control" id="txtLogin" aria-describedby="loginHelp" placeholder="Login" v-model="user.login">    
        </div>
        <div class="label-left">
           <label for="txtPassword">Password</label>
           <input type="password" class="form-control" id="txtPassword" aria-describedby="passwordHelp" placeholder="Password" v-model="user.password">    
        </div>
      </div>
      <button type="bottom" class="btn btn-primary" @click="(e) => loginUser(e)">Login</button>
   </div>
  </div>
</template>

<script>
  import { getDataFromServer } from "../../utils/DataProvider";  
  export default {  
    data: () => {
      return{
         title: 'Login',
         user: {login: '', password: ''},
      }     
    },
    methods: {
      loginUser(e){
         getDataFromServer('login_user', this.user)
        .then(obj => 
        {                 
          if(obj.data.success === true){           
            this.$store.dispatch('SET_LOGIN_USER', obj.data.data)            
            let userJson = JSON.stringify(obj.data.data)            
            localStorage.setItem('user', userJson)
            console.log("router: ", this.$router)
            this.$router.push('/admin_config')
          }
          else{
            this.flash('login user error: ' + obj.data.text , 'error', {timeout: 4500})
          }          
        })
        .catch(err => {
          this.flash('login user error: ' + err, 'error', {timeout: 4500})
        })
      }
    },
    created(){

    },
  }   
</script>

<style scoped>  
  .login-main-container{
    margin-top: 200px;
    margin-bottom: 150px;   
    text-align: center;
    display: flex;    
    flex-direction: column;    
  }

  .login-container{
    padding: 60px;
  }

  .login-fields{
    width: 500px;
    margin-left: auto;
    margin-right: auto;
  }
</style>
